import { useState } from 'react'

import { Button, ButtonProps, Icon } from '@chakra-ui/react'

import { IconComponent } from '@wwt/entities/base'

import { QuickActionTooltip } from './QuickActionTooltip'

interface QuickActionButtonProps extends ButtonProps {
	icon: IconComponent
	tooltipInfo?: {
		icon: IconComponent
		title: string
		description: string
	}
	isFirst?: boolean
}

export const QuickActionMiniButton = ({
	icon,
	tooltipInfo,
	isFirst,
	children,
	...btnProps
}: QuickActionButtonProps) => {
	const [isTooltipOpen, setIsTooltipOpen] = useState(false)
	return (
		<Button
			minW="1.25rem"
			h="100%"
			alignItems="center"
			justifyContent="center"
			cursor="pointer"
			bg="white"
			border="none"
			pr="0.875rem"
			pl={isFirst ? '0' : '0.875rem'}
			_hover={{ color: 'brand.200' }}
			_active={{}}
			onMouseOver={() => setIsTooltipOpen(true)}
			onMouseLeave={() => setIsTooltipOpen(false)}
			{...btnProps}
		>
			<Icon
				as={icon}
				boxSize="1.25rem"
				viewBox="0 0 32 32"
			/>
			{tooltipInfo && (
				<QuickActionTooltip
					isOpen={isTooltipOpen}
					icon={tooltipInfo.icon}
					title={tooltipInfo.title}
					description={tooltipInfo.description}
				/>
			)}
			{children}
		</Button>
	)
}
